import React, { useState, useEffect } from "react";

import GetStatusList from "services/GetStatusList";
import GetSupplierRequestLogs from "services/GetSupplierRequestLogs";
import formateDateTime from "utils/formateDateTime";

import { Spinner } from "@chakra-ui/react";

import data_not_found_blue_icon from "../../../assets/images/icons/general_icons/data_not_found_blue_icon.png";
import AlgorithmStatus from "components/Tags/AlgorithmStatus";

export default function FiliesTabLog(props) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [statusList, setStatusList] = useState([]);
  const [logs, setLogs] = useState([]);

  const [isLoadingLogs, setIsLoadingLogs] = useState(true);

  const fetchStatusList = async () => {
    const res = await GetStatusList();
    setStatusList(res.data);
  };

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        setIsLoadingLogs(true);
        const res = await GetSupplierRequestLogs({
          supplier_id: props.supplier_id,
          page_size: pageSize,
          page_number: currentPage,
          records_order: "DSC",
          is_custom_request: false,
        });

        // setTotalRecords(res.data.total_records);
        // setTotalPages(res.data.pages);

        setLogs(res.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingLogs(false);
      }
    };

    fetchStatusList();
    fetchLogs();
  }, [props.supplier_id]);

  const getStatusFromList = (statusId) => {
    if (statusList.length === 0) {
      fetchStatusList();

      return "";
    }

    const matchingStatus = statusList.find(
      (status) => status.status_id === statusId
    );

    const statusName = matchingStatus ? matchingStatus.status_name : undefined;

    return statusName;
  };

  return (
    <>
      {isLoadingLogs && (
        <div className="flex flex-row justify-center   h-[34rem] ">
          <Spinner className="my-auto" size="xl" />
        </div>
      )}

      {!isLoadingLogs && logs.length === 0 && (
        <div className="flex flex-row justify-center h-[32rem]    ">
          <div className="my-auto flex flex-row justify-center gap-2 ">
            <img src={data_not_found_blue_icon} />
            <p>Data Not Found</p>
          </div>
        </div>
      )}

      {!isLoadingLogs && logs.length > 0 && (
        <div className="overflow-x-auto">
          <table className=" w-full  border border-[#e9e9e9] table-auto">
            <thead>
              <tr className="bg-[#e9e9e9] h-[2.63rem]">
                <th className="pl-4 py-1.5  ">
                  <p className="table-heading">ID</p>
                </th>
                <th className="py-1.5 table-heading  ">Timestamp</th>
                <th className="py-1.5 table-heading">
                  Extraction Algorithm Status
                </th>
                <th className="py-1.5 table-heading">
                  Difference Algorithm Status
                </th>
              </tr>
            </thead>
            <tbody className=" ">
              {logs?.map((data, index) => {
                return (
                  <tr className="border-x primary-border-color hover:bg-gray-100  h-[3.13rem] ">
                    <td className="pl-2 py-2.5   ">
                      <p className="table-text text-center">{index + 1}</p>
                    </td>
                    <td className="table-text-light overflow-ellipsis overflow-hidden max-w-60 xl:max-w-xl">
                      {formateDateTime(data?.supplier_request_start_time)}
                    </td>
                    <td className="table-text-light">
                      {
                        <AlgorithmStatus
                          status_text={getStatusFromList(
                            data?.scraping_algo_status
                          )}
                        />
                      }
                    </td>
                    <td className="table-text-light">
                      <AlgorithmStatus
                        status_text={getStatusFromList(
                          data?.difference_algo_status
                        )}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {/* <TablePagination
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalRecords={totalRecords}
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        /> */}
        </div>
      )}
    </>
  );
}
